import React from 'react';
import Text from '.';

const TitleHead = ({text, size, color}) => {
    return(
        <Text 
            ownClass={`title-head `}
            text={text}
            size={size}
            color={color}/>
    )
}

export default TitleHead;